/**
 * Pauses the execution of an async function for the given number of milliseconds.
 * @param {number} ms - The number of milliseconds to pause.
 * @returns {Promise<void>} A promise that resolves after the specified delay.
 */
export const sleep = (ms) => {
  return new Promise(resolve => setTimeout(resolve, ms));
}

